import t, { AsHtml } from "utils/translate";
import Column from "components/Column";
import SiteWrapper from "components/SiteWrapper";
import StickyFooter from "components/StickyFooter";

import styles from "./styles.module.scss";

const ClinicalIneligibleSuicide = (): JSX.Element => {
  const onContinue = () => {
    window.location.href = t("NOT_ELIGIBLE_MENTAL_HEALTH_CTA1_LINK");
  };

  const messageLabel = `${t("NOT_ELIGIBLE_MENTAL_HEALTH_FOLLOWUP_BODY")} <a href="${t("NOT_ELIGIBLE_MENTAL_HEALTH_CTA2_LINK")}">${t("NOT_ELIGIBLE_MENTAL_HEALTH_CTA2_TEXT")}</a>`;

  return (
    <SiteWrapper size="small">
      <Column className={styles.content}>
        <div className={styles.logo}></div>
        <h1 className={styles.heading}>{t("NOT_ELIGIBLE_MENTAL_HEALTH_HEADER_UNI")}</h1>
        <div className={styles.text}>
          <AsHtml value={t("NOT_ELIGIBLE_MENTAL_HEALTH_BODY")} tagType="div" />
        </div>
        <div className={styles.text}>
          <AsHtml value={t("NOT_ELIGIBLE_MENTAL_HEALTH_BODY2")} tagType="div" />
        </div>
        <StickyFooter
          message={{
            label: messageLabel,
            className: styles.disclaimer
          }}
          nextButtonProps={{ onNext: onContinue, label: t("NOT_ELIGIBLE_MENTAL_HEALTH_CTA1_TEXT") }}
        />
      </Column>
    </SiteWrapper>
  );
};

export default ClinicalIneligibleSuicide;
